var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFavoriteOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 18.93994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.35,17.89h2.91a.5335.5335,0,0,1,.53.53.525.525,0,0,1-.53.52H9.11a.52442.52442,0,0,1-.09-1.04c.02,0,.03-.01.05-.01a7.53949,7.53949,0,0,0,.79-.19A12.356,12.356,0,0,0,18.95,5.79a4.74362,4.74362,0,0,0-4.74-4.74,4.80993,4.80993,0,0,0-3.73,1.81c-.02.02-.48.61-.48.61h0s-.46-.58-.48-.61A4.80993,4.80993,0,0,0,5.79,1.05,4.74362,4.74362,0,0,0,1.05,5.79,12.37129,12.37129,0,0,0,6.31,15.9a.52627.52627,0,0,1-.3.96.49158.49158,0,0,1-.3-.1A13.39327,13.39327,0,0,1,0,5.79a.40973.40973,0,0,1,.01-.11A5.78041,5.78041,0,0,1,10,1.82a5.78041,5.78041,0,0,1,9.99,3.86.40973.40973,0,0,1,.01.11A13.40277,13.40277,0,0,1,12.35,17.89Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavoriteOut);
export default __webpack_public_path__ + "static/media/iconFavoriteOut.fdb6d0f28a0c47a30dc7a228cf19ac62.svg";
export { ForwardRef as ReactComponent };